import {
  Box,
  Button,
  CircularProgress,
  Flex,
  Heading,
  Image,
  Input,
  Link,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalOverlay,
  TabPanel,
  TabPanels,
  Tabs,
} from '@chakra-ui/core';
import BigNumber from 'bignumber.js';
import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import BtcImage from '../assets/btc.svg';
import config from '../config/config';
import { getClient } from '../services/chainClient';
import { RootState } from '../store/reducers';

const EnterAddress = ({ btcAddress, setBtcAddress, onWithdraw }) => (
  <Box textAlign="center">
    <Image src={BtcImage} mx="auto" height="75px" mb={1} />
    <Heading size="md" mb={2}>
      Please enter the BTC receiving address
    </Heading>
    <Input
      width="200px"
      placeholder="Enter your BTC address"
      value={btcAddress}
      onChange={(evt) => setBtcAddress(evt.target.value)}
    ></Input>
    <Flex mt="2rem">
      <Button
        ml="auto"
        backgroundColor="blue.600"
        color="white"
        onClick={onWithdraw}
      >
        Withdraw Deposit
      </Button>
    </Flex>
  </Box>
);

const OverviewPage = ({ betSize, setPage }) => (
  <Box>
    <Heading mb={4}>Continue with backing out?</Heading>

    <Flex mt="2rem">
      <Button
        ml="auto"
        backgroundColor="blue.600"
        color="white"
        onClick={() => setPage(1)}
      >
        Decline Bet
      </Button>
    </Flex>
  </Box>
);

const WithdrawingPage = () => (
  <Box textAlign="center">
    <CircularProgress
      // @ts-ignore
      isIndeterminate
      thickness="3px"
      size="80px"
      color="blue.600"
      mb={4}
    />
    <Heading mb={4} size="md">
      Transferring your winnings...
    </Heading>
  </Box>
);

const CompletePage = ({ txHash }) => {
  const history = useHistory();
  return (
    <Box textAlign="center">
      <Heading mb={4} size="md">
        Transfer Complete!
      </Heading>

      <Heading as="h2" size="sm" mb={8} mt={8}>
        View Explorer:{' '}
        <Link
          textDecoration="underline"
          fontWeight="bold"
          href={`${config.bitcoin.explorer}/${txHash}`}
          target="_blank"
        >
          {txHash.substring(0, 15)}...
        </Link>
      </Heading>
      <Flex mt="2rem">
        <Button
          ml="auto"
          backgroundColor="blue.600"
          color="white"
          onClick={() => history.push('/dashboard')}
        >
          Go to Dashboard
        </Button>
      </Flex>
    </Box>
  );
};

const CancelBetModal = ({ contractId, isOpen, onClose }) => {
  const bet = useSelector((state: RootState) => state.bets[contractId]);
  const { betSize } = bet.betDetails;

  const [page, setPage] = useState(
    bet.stage === 'CANCELLED' && bet.withdrawable ? 1 : 0
  );
  const [btcAddress, setBtcAddress] = useState('');
  const [withdrawTxHash, setWithdrawTxHash] = useState('');

  const onWithdraw = async () => {
    console.log('withdrawWinnings');
    const bitcoin = getClient();
    console.log('bet', bet);

    const contract = bet.contract;

    const utxoAddresses = contract.isLocalParty
      ? contract.localPartyInputs.utxos.map((utxo) => utxo.address)
      : contract.remotePartyInputs.utxos.map((utxo) => utxo.address);

    console.log('utxoAddresses', utxoAddresses);

    const utxos = await bitcoin.getMethod('getUnspentTransactions')(
      utxoAddresses
    );

    let fixedInputs = utxos.map((utxo) => {
      const addr = utxoAddresses.find((a) => a === utxo.address);
      console.log('addr', addr);
      console.log('utxo', utxo);
      return {
        ...utxo,
        value: new BigNumber(utxo.amount).times(1e8).toNumber(),
        derivationPath: addr.derivationPath,
      };
    });
    fixedInputs = fixedInputs.filter(
      (v, i, a) => a.findIndex((t) => t.txid === v.txid) === i
    );
    console.log('fixedInputs', fixedInputs);

    if (fixedInputs.length > 0) {
      const txHash = await bitcoin.client.finance.wallet.sendSweepTransactionWithSetOutputs(
        btcAddress,
        false,
        [],
        fixedInputs
      );

      setWithdrawTxHash(txHash.hash);
      setPage(3);
    } else {
      // TODO: add case for already withdrawn
    }
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose} isCentered>
      <ModalOverlay>
        <ModalContent>
          <ModalCloseButton />
          <ModalBody p={4}>
            <Tabs isLazy index={page}>
              <TabPanels>
                <TabPanel>
                  <OverviewPage betSize={betSize} setPage={setPage} />
                </TabPanel>
                <TabPanel>
                  <EnterAddress
                    setBtcAddress={setBtcAddress}
                    btcAddress={btcAddress}
                    onWithdraw={onWithdraw}
                  />
                </TabPanel>
                <TabPanel>
                  <WithdrawingPage />
                </TabPanel>
                <TabPanel>
                  <CompletePage txHash={withdrawTxHash} />
                </TabPanel>
              </TabPanels>
            </Tabs>
          </ModalBody>
        </ModalContent>
      </ModalOverlay>
    </Modal>
  );
};

export default CancelBetModal;
